import qwest from 'qwest';

export function getSeasonsUsageData(pool) {
  return qwest.post(`/QuickCalcs/SeasonUsage`, {
    pool: pool.toApiFormat()})
    .then((xhr, res) => res.data);
}

export function getOptimizerPlusData({optimizerPlus, volume}) {
  return qwest.post('/QuickCalcs/OptimizerPlus', {optimizerPlus, volume})
    .then((xhr, res) => res.data);
}

export function getSystemConversion(body) {
  return qwest.post('/QuickCalcs/SystemConversion', body)
    .then((xhr, res) => {
      if (!res.success) {
        console.error('Failed to get system conversion details');
        return;
      }

      return res.data;
    });
}
